export default __webpack_public_path__ + "fonts/SaveIcon-Saved-Hover.svg";